import { render, staticRenderFns } from "./PurchasingRecordDetail.vue?vue&type=template&id=2e042901&scoped=true&"
import script from "./PurchasingRecordDetail.vue?vue&type=script&lang=js&"
export * from "./PurchasingRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e042901",
  null
  
)

export default component.exports